module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_5012.b5f9d01a.png";